var _defs, _circle, _circle2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 174 174",
    style: {
      enableBackground: "new 0 0 174 174"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    cx: 87,
    cy: 87,
    rx: 86.957,
    ry: 87
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#60C5A8"
    },
    cx: 87,
    cy: 87,
    rx: 86.957,
    ry: 87
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.3127 -0.9499 0.9499 -0.3127 4.5452 149.0939)",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFC785"
    },
    cx: 56.214,
    cy: 72.903,
    rx: 7.934,
    ry: 4.588
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3129 -0.9498 0.9498 0.3129 14.3235 165.6049)",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFC785"
    },
    cx: 121.617,
    cy: 72.903,
    rx: 7.934,
    ry: 4.589
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F5704D"
    },
    d: "M111.812,32.489c6.732,1.074,10.457,5.689,12.051,11.954 c4.15,16.307-4.537,51.673-34.609,52.094c-15.506,0.217-26.677-3.726-30.746-16.277c-4.069-12.552-5.739-32.778,3.105-44.114 C72.742,21.885,96.1,21.751,111.812,32.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#025784",
      stroke: "#025784",
      strokeWidth: 1.0844,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M76.247,115.623c-28.144,12.338-36.585,18.915-39.923,21.869c-5.143,4.551-8.162,22.106-11.195,36.508h63.672h63.674 c-3.033-14.402-5.703-31.958-10.846-36.508c-3.337-2.954-11.471-9.362-39.613-21.7L76.247,115.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F5BE92"
    },
    d: "M75.313,91.029v20.886v12.479 c7.514,8.885,19.813,9.204,27.328,0v-12.479V91.029C102.641,74.185,75.313,74.185,75.313,91.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F5BE92"
    },
    d: "M88.977,35.022c-45.863,0-29.369,59.754-26.374,64.166 c3.304,4.864,18.964,13.421,26.374,13.421c7.41,0,23.07-9.64,26.374-14.505C118.346,93.692,134.84,35.022,88.977,35.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#F5704D"
    },
    d: "M66.645,49.42c8.058,4.9,14.292-2.41,21.568,0.726 c7.277,3.134,28.148-5.364,32.443,27.761c6.886-24.023-4.74-44.141-30.998-45.284c-28.041-1.22-39.397,20.706-31.644,44.57 C57.504,64.265,60.667,55.806,66.645,49.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M74.015,115.289l-9.69,5.245l14.053,19.479L89.039,129.9L74.015,115.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M104.063,115.289l9.691,5.245l-14.053,19.479L89.039,129.9L104.063,115.289z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5704D"
    },
    d: "M65.931,47.357c0.623,3.974,6.51,4.572,9.664,4.886c6.183,0.615,13.844-1.758,18.873-5.285 c0.382-0.268,0.242-0.839-0.235-0.868c-5.357-0.335-10.217,3.413-15.596,3.864c-3.902,0.327-9.179-0.202-12.21-2.884 C66.192,46.86,65.885,47.066,65.931,47.357L65.931,47.357z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M70.258,77.052c0,0,1.49,2.515,6.071,2.515c4.58,0,5.384-2.151,5.429-2.91 c0,0-1.759-2.987-5.368-2.987S70.258,77.052,70.258,77.052z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 76.1331,
    cy: 76.6186,
    r: 2.6149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E4962"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0185,
    style: {
      stopColor: "#314E68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1059,
    style: {
      stopColor: "#3C627D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    style: {
      stopColor: "#44728E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3362,
    style: {
      stopColor: "#4A7D9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    style: {
      stopColor: "#4D83A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E85A3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    cx: 76.132,
    cy: 76.619,
    r: 2.615
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4962"
    },
    d: "M76.132,74.267c1.297,0,2.353,1.055,2.353,2.352c0,1.297-1.055,2.352-2.353,2.352 c-1.296,0-2.351-1.055-2.351-2.352C73.781,75.322,74.836,74.267,76.132,74.267 M76.132,73.741 c-1.589,0-2.877,1.288-2.877,2.877c0,1.589,1.288,2.878,2.877,2.878c1.59,0,2.878-1.288,2.878-2.878 C79.011,75.029,77.722,73.741,76.132,73.741L76.132,73.741z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.133,
    cy: 76.619,
    r: 1.202
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M107.555,77.051c0,0-1.489,2.516-6.07,2.516c-4.581,0-5.384-2.151-5.43-2.909 c0,0,1.759-2.988,5.368-2.988C105.032,73.67,107.555,77.051,107.555,77.051z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 455.7083,
    cy: 76.6186,
    r: 2.6154,
    gradientTransform: "matrix(-1 0 0 1 557.3887 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E4962"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0185,
    style: {
      stopColor: "#314E68"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1059,
    style: {
      stopColor: "#3C627D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    style: {
      stopColor: "#44728E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3362,
    style: {
      stopColor: "#4A7D9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    style: {
      stopColor: "#4D83A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E85A3"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    cx: 101.68,
    cy: 76.619,
    r: 2.615
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4962"
    },
    d: "M101.68,74.266c1.297,0,2.353,1.055,2.353,2.352s-1.055,2.352-2.353,2.352 c-1.297,0-2.352-1.055-2.352-2.352S100.383,74.266,101.68,74.266 M101.68,73.741c-1.589,0-2.878,1.289-2.878,2.878 c0,1.589,1.288,2.878,2.878,2.878c1.589,0,2.878-1.289,2.878-2.878C104.559,75.029,103.269,73.741,101.68,73.741 L101.68,73.741z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.68,
    cy: 76.619,
    r: 1.202
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E48F67"
    },
    d: "M83.862,89.112c-0.716,0.435-0.869,1.168-0.129,1.701c1.237,0.892,2.997,0.974,4.461,0.973 c1.536-0.001,3.36-0.137,4.694-0.978c0.683-0.43,1.163-1.815,0.206-2.236c-0.181-0.08-0.463,0.008-0.441,0.253 c0.029,0.325,0.334,0.63,0.275,0.929c-0.079,0.396-0.675,0.617-0.995,0.74c-0.996,0.383-2.119,0.446-3.173,0.475 c-0.935,0.025-5.768,0.093-4.765-1.724C84.042,89.162,83.948,89.06,83.862,89.112L83.862,89.112z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E48F67"
    },
    d: "M80.358,100.982c4.967,3.681,12.689,2.652,17.485-0.776c0.145-0.104,0.023-0.305-0.138-0.236 c-5.877,2.53-11.195,3.151-17.211,0.691C80.294,100.58,80.211,100.874,80.358,100.982L80.358,100.982z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5704D"
    },
    d: "M65.118,66.493c5.655-0.83,11.084-1.645,16.339,1.308c0.507,0.285,0.946-0.472,0.454-0.776 c-4.355-2.691-12.444-3.808-16.849-0.664C64.993,66.41,65.036,66.505,65.118,66.493L65.118,66.493z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5704D"
    },
    d: "M112.54,66.361c-4.405-3.144-12.493-2.027-16.848,0.664c-0.493,0.304-0.053,1.061,0.454,0.776 c5.255-2.953,10.684-2.138,16.339-1.308C112.566,66.505,112.61,66.41,112.54,66.361L112.54,66.361z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5704D"
    },
    d: "M109.409,41.313c0.337,1.506,2.92,1.193,2.724-0.369c-2.054-16.339-20.398-17.873-34.322-15.791 c-0.376-0.355-0.903-0.533-1.512-0.33c-1.271,0.423-2.541,0.846-3.812,1.269c-7.764,1.81-20.405,13.759-26.497,5.125 c-0.762-1.08-2.772-0.822-2.686,0.727c0.785,14.209,15.161,21.937,27.67,24.323c6.755,1.289,14.102,1.18,20.92,0.651 c6.346-0.492,14.359-1.44,18.836-6.491c0.511-0.577-0.13-1.456-0.829-1.074c-1.979,1.083-4.054,1.938-6.194,2.604 c0.731-1.089,0.288-2.821-1.46-2.882c-0.784-0.027-1.575-0.041-2.368-0.05c-0.427-0.661-1.252-1.102-2.14-0.925 c-1.29,0.258-2.556,0.58-3.814,0.911c-4.3-0.345-8.592-0.918-12.914-0.582c-3.193-0.47-6.306-1.285-9.262-2.688 c-5.036-2.392-9.826-8.199-4.193-12.427c2.418-1.815,5.271-3.032,8.003-4.372c1.287-0.254,2.629-0.481,4.008-0.671 c0.345-0.001,0.677-0.015,1.033-0.007c6.891,0.157,12.264,2.829,18.482,5.281c0.501,0.198,1.011-0.487,0.706-0.918 c-1.303-1.837-3.146-3.247-5.297-4.313C101.614,29.638,107.624,33.328,109.409,41.313z M52.831,36.838 c-0.016-0.015-0.033-0.03-0.049-0.045c0.027-0.003,0.055-0.004,0.083-0.007C52.854,36.804,52.842,36.82,52.831,36.838z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.79d8a186f3c933ac148a9f902e784d52.svg";
export { ForwardRef as ReactComponent };